import { useNavigate } from 'react-router-dom';
import BlackPlusIcon from '../my-page-test-icon/BlackPlusIcon';
import { t } from 'i18next';

const AddLikedArtistButton = ({ theme }: { theme: string }) => {
  const navigate = useNavigate();

  const handleAddLikedArtist = () => {
    navigate('/search-artists?notInitial=true&callback=/my', { replace: true });
  };

  return (
    <button type="button" className="flex items-center gap-[4px]" onClick={handleAddLikedArtist}>
      <BlackPlusIcon fill={theme === 'dark' ? '#CFCFD0' : '#444444'} />
      <p className="text-[15px] font-medium text-main-light-2 dark:text-main-dark-2 leading-none">
        {t('manageArtistPage.addLikedArtist')}
      </p>
    </button>
  );
};

export default AddLikedArtistButton;
